export default __webpack_public_path__ + "static/media/icon-fleets.07953b88.svg";